document.addEventListener('DOMContentLoaded', function () {
	const buttons = document.querySelectorAll('.tixfox-event-button');

	function getUTMParams() {
		const urlParams = new URLSearchParams(window.location.search);
		const utmParams = {};
		const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
		
		utmKeys.forEach(key => {
			const value = urlParams.get(key);
			if (value) {
				utmParams[key] = value;
			}
		});
		
		return utmParams;
	}

	function buildIframeURL(eventSlug) {
		const baseURL = `https://tixfox.co/embed/e/${eventSlug}`;
		const utmParams = getUTMParams();
		
		if (Object.keys(utmParams).length === 0) {
			return baseURL;
		}
		
		const queryString = new URLSearchParams(utmParams).toString();
		return `${baseURL}?${queryString}`;
	}

	buttons.forEach((button) => {
		button.addEventListener('click', function () {
			const eventSlug = this.getAttribute('data-event-slug');
			const eventTitle = this.getAttribute('data-event-title');

			if (!eventSlug) return;

			const iframeURL = buildIframeURL(eventSlug);

			const modal = document.createElement('div');
			modal.className = 'tixfox-modal';
			modal.innerHTML = `
				<div class="tixfox-modal-content">
					<button class="tixfox-modal-close" aria-label="Close">&times;</button>
					<div class="tixfox-loader">
						<div class="tixfox-loader-spinner"></div>
					</div>
					<iframe
						class="tixfox-modal-iframe"
						src="${iframeURL}"
						title="${eventTitle || 'Event'}"
					></iframe>
				</div>
			`;

			document.body.appendChild(modal);

			const iframe = modal.querySelector('.tixfox-modal-iframe');
			const loader = modal.querySelector('.tixfox-loader');

			iframe.addEventListener('load', function() {
				loader.style.display = 'none';
			});

			setTimeout(() => {
				modal.classList.add('active');
			}, 10);

			const closeButton = modal.querySelector('.tixfox-modal-close');
			closeButton.addEventListener('click', function () {
				modal.classList.remove('active');
				setTimeout(() => {
					modal.remove();
				}, 300);
			});

			modal.addEventListener('click', function (e) {
				if (e.target === modal) {
					modal.classList.remove('active');
					setTimeout(() => {
						modal.remove();
					}, 300);
				}
			});

			document.addEventListener('keydown', function (e) {
				if (e.key === 'Escape' && modal.classList.contains('active')) {
					modal.classList.remove('active');
					setTimeout(() => {
						modal.remove();
					}, 300);
				}
			});
		});
	});
});
